import React, { useState, useCallback } from "react";
import { Checkbox } from "primereact/checkbox";
import Button from "../../../../components/Button";
import ImageEvidance from "../modals/ImageEvidance";
import Detail from "../modals/Detail";

import InstallmentServices from "../../../../services/InstallmentDeduction";
import Badge from "../../../../components/Badge";

function BodyTable({ data, index, getNewData, pageNumber, limitDataPages }) {
  const [complaintsState, setComplaintsState] = useState(
    Array.isArray(data?.items) ? data.items.map((item) => ({ ...item })) : []
  );

  const [showInputValue, setShowInputValue] = useState(null);
  const [valueShippingCost, setValueShippingCost] = useState("");
  const [dataDetail, setDataDetail] = useState(null);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalImage, setModalImage] = useState(false);
  const [image, setImage] = useState(null);

  const complaints = Array.isArray(data?.items) ? data.items : [];
  const checkBox = complaintsState;
  const baseHeight = 40;
  const dynamicHeight = complaints.length > 0 ? baseHeight * complaints.length : baseHeight;
  const dynamicStyle = {
    minHeight: `${dynamicHeight}px`,
    maxHeight: `${dynamicHeight}px`,
    height: `${dynamicHeight}px`,
  };

  const getRowBackground = (index) => (index % 2 === 0 ? "#fcfcfc" : "#ffffff");

  const widthStyle = {
    no: {
      width: "80px",
      minWidth: "80px",
      maxWidth: "80px",
      flexShrink: "0",
      position: "sticky",
      left: "0",
    },
    worker_id: {
      width: "135px",
      minWidth: "135px",
      maxWidth: "135px",
      flexShrink: "0",
      position: "sticky",
      left: "80px",
    },
    worker_name: {
      width: "200px",
      minWidth: "200px",
      maxWidth: "200px",
      flexShrink: "0",
      position: "sticky",
      left: "215px",
    },
    worker_type: { width: "200px", minWidth: "200px", maxWidth: "200px" },
    initial_amount: { width: "200px", minWidth: "200px", maxWidth: "200px" },
    cicilanUnpaid: { width: "200px", minWidth: "200px", maxWidth: "200px" },
    ongkir: { width: "200px", minWidth: "200px", maxWidth: "200px" },
    deduction: { width: "200px", minWidth: "200px", maxWidth: "200px" },
    installmentType: { width: "200px", minWidth: "200px", maxWidth: "200px" },
    notes: { width: "365px", minWidth: "365px", maxWidth: "365px" },
    durasi: { width: "170px", minWidth: "170px", maxWidth: "170px" },
    status: { width: "200px", minWidth: "200px", maxWidth: "200px" },
    final_amount: { width: "250px", minWidth: "250px", maxWidth: "250px" },
    action: {
      width: "100px",
      minWidth: "100px",
      maxWidth: "100px",
      flexShrink: "0",
      position: "sticky",
      right: "0",
    },
  };

  // const formatCurrency = (num) =>
  //   new Intl.NumberFormat("id-ID", {
  //     style: "currency",
  //     currency: "IDR",
  //   }).format(num || 0);

  const handleCheckboxChange = async (index, checked, id) => {
    setComplaintsState((prev) => {
      const updated = [...prev];
      updated[index].deduction_mark = checked ? 1 : 0;
      return updated;
    });

    try {
      await InstallmentServices.checklist(data.id, id, checked ? 1 : 0);
    } catch (error) {
      console.error("Error updating checklist:", error);
    } finally {
      getNewData();
    }
  };

  const handleEditClick = (i, currentValue) => {
    setShowInputValue(i);
    setValueShippingCost(currentValue?.toString() || "");
  };

  const detailHandler = useCallback(
    (id, workerName, data) => {
      data.id = id;
      data.worker_name = workerName;
      setDataDetail(data);
      setModalDetail(true);
    },
    [setDataDetail, setModalDetail]
  );

  const imageHandler = useCallback((imageUrl) => {
    setImage(imageUrl);
    setModalImage(true);
  }, []);

  const closeAllModals = useCallback(() => {
    setModalDetail(false);
    setModalImage(false);
  }, []);

  const closeImageModals = useCallback(() => {
    setModalImage(false);
  }, []);

  const handleValueChange = (e) => {
    const rawValue = e.target.value.replace(/[^\d]/g, "");
    setValueShippingCost(rawValue);
  };

  const handleSave = async (i, Id, itemId) => {
    console.log("itemId", itemId);
    const updated = [...complaintsState];
    updated[i].shipping_cost = Number(valueShippingCost) || 0;
    setComplaintsState(updated);
    setShowInputValue(null);

    try {
      await InstallmentServices.shippingCost(Id, {
        item_id: itemId,
        shipping_cost: Number(valueShippingCost) || 0,
      });
    } catch (error) {
      console.error("Error updating shipping cost:", error);
    } finally {
      getNewData();
    }
  };

  const formatCurrency = (value) =>
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      maximumFractionDigits: 0,
    }).format(value || 0);

  if (!data) {
    return (
      <div className="text-center text-muted">
        <h6>Loading data...</h6>
      </div>
    );
  }

  return (
    <>
      {modalDetail && (
        <Detail activeModal={modalDetail} closeModal={closeAllModals} data={dataDetail} imageHandler={imageHandler} />
      )}
      {modalImage && <ImageEvidance activeModal={modalImage} closeModal={closeImageModals} data={image} />}
      {/* No */}
      <div
        className="flex flex-row justify-content-start align-items-start border-right-1 border-200"
        style={{ ...widthStyle.no, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
            {(pageNumber - 1) * limitDataPages + index + 1}
          </h6>
        </div>
      </div>

      {/* Worker ID */}
      <div
        className="flex flex-row justify-content-start align-items-start border-right-1 border-200"
        style={{ ...widthStyle.worker_id, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
            {data.worker_id ?? "-"}
          </h6>
        </div>
      </div>

      {/* Worker Name */}
      <div
        className="flex flex-row justify-content-start align-items-start border-right-1 border-200"
        style={{ ...widthStyle.worker_name, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
            {data.worker_name ?? "-"}
          </h6>
        </div>
      </div>

      {/* Worker Type */}
      <div
        className="flex flex-row justify-content-start align-items-start border-right-1 border-200"
        style={{ ...widthStyle.worker_type, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
            {data.worker_type ?? "-"}
          </h6>
        </div>
      </div>

      {/* Amount */}
      <div
        className="flex flex-column justify-content-start align-items-start border-right-1 border-200"
        style={{ ...widthStyle.initial_amount, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
            {formatCurrency(data.initial_amount)}
          </h6>
        </div>
      </div>

      {/* Cicilan Unpaid */}
      <div
        className="flex flex-column justify-content-center align-items-center border-right-1 border-200"
        style={{ ...widthStyle.cicilanUnpaid, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        {complaints.length > 0 ? (
          complaints.map((complain, index) => (
            <div
              key={index}
              className={`flex flex-row justify-content-start align-items-center w-full text-center p-3 ${
                index !== complaints.length - 1 ? "border-bottom-1 border-200" : ""
              }`}
              style={{
                minHeight: baseHeight,
                maxHeight: baseHeight,
                height: baseHeight,
                background: complain.deduction_mark === 1 ? "rgb(46, 187, 169, 0.15)" : "",
              }}
            >
              <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
                {formatCurrency(complain.unpaid_amount)}
              </h6>
            </div>
          ))
        ) : (
          <div className="flex flex-row justify-content-start align-items-center w-full p-3">
            <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>-</h6>
          </div>
        )}
      </div>

      {/* Ongkir */}
      <div
        className="flex flex-column justify-content-center align-items-center border-right-1 border-200"
        style={{ ...widthStyle.ongkir, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        {complaints.length > 0 ? (
          complaints.map((complain, index) => (
            <div
              key={index}
              className={`flex flex-row justify-content-between align-items-center w-full h-full text-center p-3 ${
                index !== complaints.length - 1 ? "border-bottom-1 border-200" : ""
              }`}
              style={{
                minHeight: baseHeight,
                maxHeight: baseHeight,
                height: baseHeight,
                background: complain.deduction_mark === 1 ? "rgb(46, 187, 169, 0.15)" : "",
              }}
            >
              {showInputValue === index ? (
                <input
                  type="text"
                  autoFocus
                  value={formatCurrency(valueShippingCost)}
                  onChange={handleValueChange}
                  onBlur={() => handleSave(index, data.id, complain.id)}
                  onKeyDown={(e) => e.key === "Enter" && handleSave(index, data.id, complain.id)}
                  className="form-control text-xs text-left fw-bold m-0"
                  style={{ height: "100%", maxWidth: "80%", padding: "15px 15px" }}
                />
              ) : (
                <h6
                  className={`m-0 p-0 fw-bold text-xs ${
                    complain.shipping_cost ? "text-danger" : data.is_posting === 1 ? "color-primary" : ""
                  }`}
                >
                  {formatCurrency(complain.shipping_cost)}
                </h6>
              )}

              {complain.can_edit && data.is_posting === 0 && (
                <div
                  className="p-0 m-0 cursor-pointer flex flex-row justify-content-center align-items-center h-full"
                  onClick={() => handleEditClick(index, complain.shipping_cost)}
                >
                  <i className="fa fa-edit p-0 m-0" style={{ fontSize: "16px" }}></i>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="flex flex-row justify-content-start align-items-center w-full p-3">
            <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>-</h6>
          </div>
        )}
      </div>

      {/* Deduction */}
      <div
        className="flex flex-column justify-content-center align-items-start border-right-1 border-200"
        style={{ ...widthStyle.deduction, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        {complaints.length > 0 ? (
          complaints.map((complain, index) => (
            <div
              key={index}
              className={`flex flex-row justify-content-start align-items-center w-full text-center p-3 ${
                index !== complaints.length - 1 ? "border-bottom-1 border-200" : ""
              }`}
              style={{
                minHeight: baseHeight,
                maxHeight: baseHeight,
                height: baseHeight,
                background: complain.deduction_mark === 1 ? "rgb(46, 187, 169, 0.15)" : "",
              }}
            >
              <h6
                className={`m-0 p-0 fw-bold text-xs ${
                  complain.deduction_amount > 0 ? "text-danger" : data.is_posting === 1 ? "color-primary" : ""
                }`}
              >
                {formatCurrency(complain.deduction_amount)}
              </h6>
            </div>
          ))
        ) : (
          <div className="flex flex-row justify-content-start align-items-center w-full p-3">
            <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>-</h6>
          </div>
        )}
      </div>

      {/* Installment Type */}
      <div
        className="flex flex-column justify-content-center align-items-center border-right-1 border-200"
        style={{ ...widthStyle.installmentType, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        {complaints.length > 0 ? (
          complaints.map((complain, index) => (
            <div
              key={index}
              className={`flex flex-row justify-content-center align-items-center w-full text-center ${
                index !== complaints.length - 1 ? "border-bottom-1 border-200" : ""
              }`}
              style={{
                minHeight: baseHeight,
                maxHeight: baseHeight,
                height: baseHeight,
                background: complain.deduction_mark === 1 ? "rgb(46, 187, 169, 0.15)" : "",
              }}
            >
              <div className="flex flex-column justify-content-center align-items-center w-full p-3">
                <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
                  {complain.installment_type
                    ? complain.installment_type.charAt(0).toUpperCase() + complain.installment_type.slice(1)
                    : "-"}
                </h6>
              </div>
            </div>
          ))
        ) : (
          <h6 className="m-0 p-0 fw-bold text-xs text-muted">-</h6>
        )}
      </div>

      {/* Note */}
      <div
        className="flex flex-column justify-content-center align-items-center border-right-1 border-200"
        style={{ ...widthStyle.notes, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        {complaints.length > 0 ? (
          complaints.map((complain, index) => (
            <div
              key={index}
              className={`flex flex-row justify-content-center align-items-center w-full text-center ${
                index !== complaints.length - 1 ? "border-bottom-1 border-200" : ""
              }`}
              style={{
                minHeight: baseHeight,
                maxHeight: baseHeight,
                height: baseHeight,
                background: complain.deduction_mark === 1 ? "rgb(46, 187, 169, 0.15)" : "",
              }}
            >
              <div className="flex flex-column justify-content-center align-items-center w-full p-3">
                <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
                  {complain.note ? complain.note : "-"}
                </h6>
              </div>
            </div>
          ))
        ) : (
          <h6 className="m-0 p-0 fw-bold text-xs text-muted">-</h6>
        )}
      </div>

      {/* Durasi */}
      <div
        className="flex flex-column justify-content-center align-items-center border-right-1 border-200"
        style={{ ...widthStyle.durasi, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        {complaints.length > 0 ? (
          complaints.map((complain, index) => (
            <div
              key={index}
              className={`flex flex-row justify-content-center align-items-center w-full text-center ${
                index !== complaints.length - 1 ? "border-bottom-1 border-200" : ""
              }`}
              style={{
                minHeight: baseHeight,
                maxHeight: baseHeight,
                height: baseHeight,
                background: complain.deduction_mark === 1 ? "rgb(46, 187, 169, 0.15)" : "",
              }}
            >
              <div className="flex flex-column justify-content-center align-items-center w-full p-3">
                <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
                  {complain.installment_phase ?? "-"}
                </h6>
              </div>
            </div>
          ))
        ) : (
          <h6 className="m-0 p-0 fw-bold text-xs text-muted">-</h6>
        )}
      </div>

      {/* Status */}
      <div
        className="flex flex-column justify-content-center align-items-center border-right-1 border-200"
        style={{ ...widthStyle.status, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        {complaints.length > 0 ? (
          complaints.map((complain, index) => (
            <div
              key={index}
              className={`flex flex-row justify-content-center align-items-center w-full text-center ${
                index !== complaints.length - 1 ? "border-bottom-1 border-200" : ""
              }`}
              style={{
                minHeight: baseHeight,
                maxHeight: baseHeight,
                height: baseHeight,
                background: complain.deduction_mark === 1 ? "rgb(46, 187, 169, 0.15)" : "",
              }}
            >
              <div className="flex flex-column justify-content-center align-items-center w-full p-3">
                <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
                  {complain.status ?? "-"}
                </h6>
              </div>
            </div>
          ))
        ) : (
          <h6 className="m-0 p-0 fw-bold text-xs text-muted">-</h6>
        )}
      </div>

      {/* Total */}
      <div
        className="flex flex-row justify-content-start align-items-start"
        style={{ ...widthStyle.final_amount, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
            {formatCurrency(data.final_amount)}
          </h6>
        </div>
      </div>

      {/* Action (Checkbox) */}
      <div
        className="flex flex-column justify-content-center align-items-center border-left-1 border-200"
        style={{ ...widthStyle.action, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        {checkBox.length > 0 ? (
          checkBox.map((complain, i) => (
            <div
              key={i}
              className={`flex flex-row justify-content-center align-items-center w-full text-center ${
                i !== checkBox.length - 1 ? "border-bottom-1 border-200" : ""
              }`}
              style={{
                minHeight: baseHeight,
                background: complain.deduction_mark === 1 ? "rgb(46, 187, 169, 0.15)" : "",
              }}
            >
              {data.is_posting === 0 ? (
                <div className="flex flex-row justify-content-center align-items-center w-full p-3 gap-2">
                  <Button
                    button="btn-primary btn-sm"
                    icon="fa fa-eye"
                    onClick={() => detailHandler(data.id, data.worker_name, data)}
                  ></Button>
                  <Checkbox
                    disabled={data.is_posting === 1}
                    checked={complain.deduction_mark === 1}
                    onChange={(e) => handleCheckboxChange(i, e.checked, complain.id)}
                  />
                </div>
              ) : (
                <Badge badge="bg-primary pt-1 white-color" name="posted" type="rounded-pill" />
              )}
            </div>
          ))
        ) : (
          <>
            {data.is_posting === 1 ? (
              <Badge badge="bg-primary pt-1 white-color" name="posted" type="rounded-pill" />
            ) : (
              '-'
            )}
          </>
        )}
      </div>
    </>
  );
}

export default BodyTable;
